<template>
    <h1>Whoops! 404</h1>
</template>

<script>
export default({
  name: 'not-found',
})
</script>
